// 组件对象，大写
import objectJsonEditAPI from './objectJsonEditAPI.vue'
export default objectJsonEditAPI
